import { Component, Input, HostBinding } from '@angular/core';


@Component({
  moduleId: module.id,
  selector: 'plus-icon',
  template: '<span class="vertical-line line"></span><span class="horizontal-line  line"></span>',
  styleUrls: ['plus-icon.component.scss'],
})
export class PlusIconComponent {
  @HostBinding('class.plus-icon') plusIcon: boolean = true;

  @HostBinding('class.expanded')
  @Input() expaned: boolean = false;

  @HostBinding('class.inverted')
  @Input() inverted: boolean = false;

  @HostBinding('class.plus-icon-small')
  @Input() small: boolean = false;

  @HostBinding('class.plus-icon-big')
  @Input() big: boolean = false;

}
